import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Hash } from "@phosphor-icons/react/Hash";
import { TextAa } from "@phosphor-icons/react/TextAa";
import map from "lodash/map";
import upperFirst from "lodash/upperFirst";

const InputAdornmentIcon = {
	string: <TextAa />,
	number: <Hash />,
};

export const PropertiesForm = ({ properties }) => {
	return (
		<form>
			{map(properties, (value, name) => {
				const type = typeof value;
				return (
					<FormControl>
						<InputLabel>{upperFirst(name)}</InputLabel>
						<OutlinedInput
							fullWidth
							name={name}
							endAdornment={
								<InputAdornment position="end">
									{InputAdornmentIcon[type] || ""}
								</InputAdornment>
							}
						/>
						<FormHelperText>{name}</FormHelperText>
					</FormControl>
				);
			})}
		</form>
	);
};
